// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  // Sending History Change Event
  window.gtag("event", "page_view", {
    send_to: ["G-9JF23K1GJC", "MC-4BX3XNG6JL"],
    page_path: params.currentLocation,
    page_title: "Checkout - Receipt",
    page_location: params.currentLocation,
    ignore_referrer: true,
  });
  // Sending Purchase Event
  window.gtag("event", "purchase", {
    send_to: ["G-9JF23K1GJC", "MC-4BX3XNG6JL"],
    transaction_id: params.shopOrderId,
    value: params.totalPrice,
    currency: params.currency,
    shipping: params.shippingCharge,
    items: getConvertedItems(params.items),
    ignore_referrer: true,
    breeze_event_type: "breeze_purchase",
    breeze_event_send_to: ["G", "MC"],
    breeze_event_time: new Date().toISOString(),
  });
  // Sending Conversion Event to Google Analytics
  // window.gtag("event", "conversion", {
  //   send_to: "AW-473219200/_IIBCJe70tsBEL6ayMwC",
  // });
  // Sending History Change Event to Google Ads
  window.gtag("event", "page_view", {
    send_to: ["G-9JF23K1GJC", "MC-4BX3XNG6JL"],
    page_path: "/pages/thank-you",
    page_title: getGAOrderCompleteTitle(),
    page_location: params.currentLocation,
  });
}
// ----------------- END PURCHASE SCRIPT --------------------------------------

// ----------------- START ADD_PAYMENT_INFO SCRIPT ----------------------------

// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});
// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.error("Error in triggering merchants add Payment info script: ", e);
  }
}
// merchant script for `add_payment_info` will be pasted here
function merchantAddPaymentInfoCustomCode(params) {
  // paste the snippet out here
  console.log("@@@ start add payment info");

  // initializing
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "G-9JF23K1GJC");

  // START OF MERCHANT CENTER CODE
  gtag("event", "add_payment_info", {
    send_to: ["G-9JF23K1GJC"],
    transaction_id: params.shopOrderId,
    value: params.totalPrice,
    currency: params.currency,
    shipping: params.shippingCharge,
    items: convertToMerchantParams(params.items),
    breeze_event_type: "breeze_add_payment_info",
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "page_view", {
    send_to: ["G-9JF23K1GJC", "MC-4BX3XNG6JL"],
    page_path: "/checkout/processing",
    page_title: "Checkout - Processing",
    page_location: window.location.href,
    ignore_referrer: "true",
    breeze_event_type: "breeze_page_view",
    breeze_event_time: new Date().toISOString(),
  });

  function convertToMerchantParams(items) {
    return items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: item.quantity,
        variant: item.variant,
      };
    });
  }
  console.log("@@@ end add payment info");
  gtag("event", "page_view", {
    send_to: ["G-9JF23K1GJC", "MC-4BX3XNG6JL"],
    page_path: params.currentLocation,
    page_title: "Checkout - Processing",
    page_location: params.currentLocation,
    ignore_referrer: true,
  });
  // // Sending History Change Event to Google Ads
  gtag("event", "page_view", {
    page_location: params.currentLocation,
    page_referrer: params.currentLocation,
    send_to: "G-9JF23K1GJC",
  });
  // // Sending History Change Event to Merchant Center
  // gtag("event", "page_view", {
  //   page_location: params.currentLocation,
  //   page_referrer: params.currentLocation,
  //   send_to: "MC-HEYJ5GT5HE",
  // });
  // // Sending History Change Event to Google Analytics
  // gtag("event", "page_view", {
  //   page_location: params.currentLocation,
  //   page_referrer: params.currentLocation,
  //   send_to: "G-H0JTXJRGG5",
  // });
}

// ----------------- END ADD_PAYMENT_INFO SCRIPT ------------------------------

// ----------------- START BEGIN_CHECKOUT SCRIPT ------------------------------

// `breeze-initiate-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}

// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  gtag("event", "page_view", {
    send_to: ["G-9JF23K1GJC", "MC-4BX3XNG6JL"],
    page_path: params.currentlocation,
    page_title: "Checkout - Contact Information",
    page_location: params.currentlocation,
    ignore_referrer: "true",
    breeze_event_type: "breeze_checkout_contact_information",
    breeze_event_send_to: ["G", "MC"],
    breeze_event_time: new Date().toISOString(),
  });

  //
  gtag("event", "begin_checkout", {
    send_to: ["G-9JF23K1GJC"],
    ecomm_prodid: create,
    function: to,
    return: item,
    ids,
    ecomm_totalvalue: params.totalPrice,
    ecomm_pagetype: "cart",
    value: params.totalPrice,
    currency: params.currency,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_checkout_initiated",
    breeze_event_send_to: ["G"],
    breeze_event_time: new Date().toISOString(),
  });

  ///////////////////////////////
  // END GOOGLE ADS AND MERCHANT CENTER PURCHASE EVENT CODE
  ///////////////////////////////
}

// ----------------- END BEGIN_CHECKOUT SCRIPT --------------------------------

// ----------------- Common Helper Functions ----------------------------------

// function to get the screen resolution in particular format (i.e. '2560x1440')
function getScreenResolution() {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  return screenHeight + "x" + screenWidth;
}

// function to return language used in GA config (i.e. "en-gb", "en-us")
function getLanguage() {
  return "en-gb";
}

// function to return order complete page title
function getGAOrderCompleteTitle() {
  return "Breeze Checkout Thank You Page";
}

// function to return GA clientId if present or
function getGAClientIDfromMeasurementID() {
  try {
    var match = document.cookie.match("(?:^|;)\\s*_ga=([^;]*)"),
      raw = match ? decodeURIComponent(match[1]) : null;
    if (raw) {
      match = raw.match(/(\d+\.\d+)$/);
    }
    return match ? match[1] : null;
  } catch (e) {
    console.log("Exception: unable to get GA clientId");
  }
  return null;
}

// function to return merchants domain
function getMerchantDomain() {
  try {
    const currentDomain = window.location.hostname;
    const domainParts = currentDomain.split(".");
    const tld = domainParts.slice(-2).join(".");
    return tld;
  } catch {
    console.log("Exception: unable to get merchant domain");
  }
  return null;
}

// function to return current page url
function getCurrentPageUrl() {
  return window.location.href;
}

// function to return converted cart items
function getConvertedItems(items) {
  return items.map((item) => {
    return {
      id: item.id,
      name: item.name,
      price: item.price,
      quantity: item.quantity,
      variant: item.variant,
    };
  });
}

// ----------------- Common Helper Functions ----------------------------------
